module.exports = __webpack_public_path__ + "static/img/newP.2fa6e98.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newP.png
// module id = Y3Lk
// module chunks = 32